import React from "react";
import ItemView from "../Components/CartComp/ItemView";
import NavBar from "../Components/NavBar/NavBar";

const Cart = () => {
  return (
    <div>
      {/* <NavBar /> */}
      <ItemView />
    </div>
  );
};

export default Cart;
